import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  IInternationalStudentPage,
  IMakeAClaimCard,
  IStrapiDocument,
} from 'src/app/interfaces/strapi';
import StrapiService from 'src/app/services/strapi.service';
import { NgFor } from '@angular/common';
import { IMakeAClaimButton, MakeAClaimCardComponent } from '../make-a-claim-card/make-a-claim-card.component';

@Component({
    selector: 'app-make-a-claim',
    templateUrl: './make-a-claim.component.html',
    styleUrls: ['./make-a-claim.component.scss'],
    imports: [NgFor, MakeAClaimCardComponent],
    changeDetection:ChangeDetectionStrategy.OnPush,
})
export class MakeAClaimComponent implements OnInit {
  public internationalStudentData: IInternationalStudentPage = <
    IInternationalStudentPage
  >{};

  public loading = false;

  private cdr = inject(ChangeDetectorRef);

  public constructor(
    private strapi: StrapiService,
    private router: Router,
  ) {}

  public ngOnInit(): void {
    this.updateLoadingState(true);
    this.strapi.getInternationalStudentPage().subscribe({
      next: (
        internationalStudentData: IStrapiDocument<IInternationalStudentPage>
      ) => {
        this.internationalStudentData =
            internationalStudentData.data.attributes;
        this.updateLoadingState(false);
        this.cdr.markForCheck()
      },
      error: () => {
          this.updateLoadingState(false);
      }
    });
  }

  public updateLoadingState(loadingState: boolean): void {
    this.loading = loadingState;
    this.cdr.markForCheck();
  }

  public navigateToContactUs(): void {
    this.router
      .navigateByUrl('app/international-student/contact-us')
      .finally(() => false);
  }

  /**
   * Format title with its index for the make a claim cards
   * @param string title
   * @param number index
   * @returns
   */
  public processTitle(title: string | null, index: number): string {
    if (!title) return '';
    return `${index + 1}. ${title}`;
  }

  /**
   * return formatted button object for the make a claim cards
   * @param IMakeAClaimCard card
   * @returns IMakeAClaimButton
   */
  public getCardButtonObject(card: IMakeAClaimCard): IMakeAClaimButton {
    return {
      button_text: card.button_text,
      show_button: card.show_make_a_claim_button,
    } as IMakeAClaimButton;
  }
}
